import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import theme from '../../utils/theme'

const TextBox = styled(Input)`
  margin-top: ${props => props.theme.spacing(4)}px;
`

const StakeInput = props => {
  const { inputHandler, stake, disabled } = props

  return (
    <FormControl>
      <InputLabel>Stake</InputLabel>
      <TextBox
        id="adornment-amount"
        type="number"
        placeholder="0.00"
        onChange={e => inputHandler(e.target.value)}
        value={stake || ''}
        disabled={disabled}
        startAdornment={
          <InputAdornment
            position="start"
            style={{
              fontSize: '0.778em',
              lineHeight: '1em',
            }}
          >
            $
          </InputAdornment>
        }
      />
    </FormControl>
  )
}

StakeInput.propTypes = {
  stake: PropTypes.number,
  inputHandler: PropTypes.func,
  disabled: PropTypes.bool,
}

export default StakeInput
